import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import CordycepsSection from '../components/CordycepsSection';
import ScienceSection from '../components/ScienceSection';
import HistorySection from '../components/HistorySection';
import BenefitsSection from '../components/BenefitsSection';
import ProcessSection from '../components/ProcessSection';
import PhilosophySection from '../components/PhilosophySection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <CordycepsSection />
      <ScienceSection />
      <HistorySection />
      <BenefitsSection />
      <ProcessSection />
      <PhilosophySection />
      <ContactSection />
    </main>
  );
};

export default HomePage;
